const DojoReportNotifications = Object.freeze({
    REPORT_FINISHED: 'REPORT_FINISHED',
    REPORT_STARTED: 'REPORT_STARTED',
});

module.exports = DojoReportNotifications;
